<template>
  <div class="protocol">
    <br />

    <div class="bt">
      Welcome to read the &quot;{{ appName }} &quot;SVIP&quot; Service
      Agreement&quot; and activate {{ appName }} &quot;SVIP&quot;!
    </div>

    <div class="bt">
      Before you activate the &quot;SVIP&quot; service, please be sure to read
      carefully and fully understand the contents of each clause, especially the
      clauses exempting or limiting liability, legal application and dispute
      resolution clauses. If you have any questions about the agreement, you can
      consult customer service.
    </div>

    <div class="bt">
      If you are under 18 years old, please read this agreement with a legal
      guardian.
    </div>

    <div class="bt">
      If you do not agree with any content of this agreement or cannot
      accurately understand the meaning and interpretation of the terms, please
      do not proceed further. If you purchase or use the &quot;SVIP&quot;
      service, it means that you have reached an agreement with
      {{ appName }} and voluntarily accept all the contents of this agreement.
    </div>

    <div class="bt">{{ appName }} &quot;SVIP&quot; Service Agreement</div>

    <div class="bt">
      Article 1 Acceptance and Amendment of Service Agreement
    </div>

    1.1 The &quot;{{ appName }} &quot;SVIP&quot; Service Agreement&quot;
    (referred to as &quot;this Agreement&quot;) is a legal agreement between you
    and {{ appName }} regarding the various services provided by
    {{ appName }} in the {{ appName }} value-added service &quot;SVIP&quot;
    (hereinafter collectively referred to as &quot;SVIP&quot;). This agreement
    is based on the &quot;{{ appName }} User Agreement&quot;, &quot;{{
      appName
    }}
    Privacy Protection Guidelines&quot; and {{ appName }} related agreement
    specifications (collectively referred to as &quot;{{ appName }} Terms of
    Service&quot;), and is inseparable from them; at the same time,
    {{ appName }} releases from time to time the relevant &quot;SVIP&quot;
    Agreements, activity rules, etc. are also part of this agreement. When using
    the &quot;SVIP&quot; service, you should abide by this agreement,
    {{ appName }}&#39;s terms of service, and all the aforementioned relevant
    agreements, activity rules, and other terms. 1.2 {{ appName }} may modify or
    change &quot;SVIP&quot; and/or this Agreement based on the overall planning
    of &quot;SVIP&quot;, etc. If you do not agree to the aforementioned
    modifications or changes to &quot;SVIP&quot; and/or this Agreement, you may
    stop using it.&quot; SVIP”service. Your use of the &quot;SVIP&quot; service
    (including but not limited to payment behavior or completion of all
    procedures to become a &quot;SVIP&quot; without raising any objection to
    this agreement to {{ appName }} during the process, or use of the
    &quot;SVIP&quot; service, etc.) is deemed to be You accept and agree to all
    terms of this Agreement, including but not limited to the foregoing
    modifications and changes. 1.3 After you activate the &quot;SVIP&quot;
    service, the specific services you can actually use may be different due to
    different software versions, devices, operating systems, etc. and
    third-party reasons. This may cause you inconvenience. We express our
    understanding and will not make any claims against {{ appName }} or hold
    {{ appName }} responsible for this. At the same time, the &quot;{{
      appName
    }}
    &quot;SVIP&quot; Service Agreement&quot; may be different due to the
    software version you are using. You understand and agree that the final
    version of this agreement shall be the agreement version provided by the
    latest client version of {{ appName }}.

    <div class="bt">Article 2 Service Description</div>

    2.1 The &quot;SVIP&quot; service is a paid value-added service provided by
    {{ appName }} to users in its mobile client. You need to pay the relevant
    fees before you can enjoy the various rights and interests of
    &quot;SVIP&quot;. 2.2 User or &quot;you&quot;: refers to the individual or
    single entity who enjoys the &quot;SVIP&quot; service provided by
    {{ appName }}. 2.3 While providing &quot;SVIP&quot; with a number of
    exclusive privileges and value-added services, {{ appName }} will do its
    best to ensure the stability of the &quot;SVIP&quot; service and provide
    various technical and customer service support. When a technical failure
    affects the normal provision of services, {{ appName }} will
    {{ appName }} will troubleshoot for you as soon as possible.

    <div class="bt">Article 3 Activation of “SVIP” service</div>

    3.1 You confirm that you are a natural person, legal person or other
    organization with full civil rights and full capacity for civil conduct, and
    have the ability to independently bear responsibility for all your actions
    using the &quot;SVIP&quot; service. If you do not have the aforementioned
    subject qualifications, {{ appName }} has the right to refuse to provide you
    with &quot;SVIP&quot; services in accordance with laws and regulations. 3.2
    You can activate the &quot;SVIP&quot; service by completing payment through
    the payment method approved by {{ appName }} on the service activation page
    in the {{ appName }} client. 3.3 You may not activate this service for
    yourself or others through any of the following methods: (1) For
    non-personal use purposes such as profit and business; (2) Through any robot
    software, spider software, crawler software, screen swiping software and
    other programs, scripts, software, etc.; (3) By any unfair means or in
    violation of the principle of good faith (such as exploiting loopholes in
    rules, exploiting system loopholes, black industry, speculation, etc.); (4)
    Modify &quot;SVIP&quot; service period, consumption amount, transaction
    status and other information through technical means; (5) Through methods
    not approved by {{ appName }}; (6) By infringing upon the legal rights and
    interests of {{ appName }} or others; (7) Violate other relevant laws,
    administrative regulations, national policies, etc. If you violate the above
    provisions, {{ appName }} has the right to modify, restrict, suspend or
    terminate all or part of your &quot;SVIP&quot; services based on your actual
    situation without any compensation or refund. 3.4 When activating services,
    you should carefully check specific information such as account name,
    service type and duration, and read, confirm and comply with relevant
    agreements and usage methods. If there is an error in opening an account,
    activating a service, or activating a wrong duration due to your personal
    reasons, {{ appName }} will not refund the fees collected. 3.5 You hereby
    understand and agree that {{ appName }} may provide different value-added
    services or rates to &quot;SVIP&quot; with different identities or different
    stages of recharge/renewal based on actual conditions. The specific
    preferential policies are subject to the information published by
    {{ appName }} on the relevant service pages. 3.6 The &quot;SVIP&quot;
    service can only be used by those who apply for an account and cannot be
    transferred between different {{ appName }} accounts. 3.7 After you
    successfully activate &quot;SVIP&quot;, you can enjoy a number of exclusive
    privileges and services, which are subject to the actual ones provided by
    {{ appName }}. The &quot;SVIP&quot; service adopts a monthly settlement
    method. The monthly settlement date is the 30th day from the date of
    activating the &quot;SVIP&quot; service. If you do not use the corresponding
    privileges before the monthly settlement date, they will expire after the
    monthly settlement date. Specifically, you You can query it on the
    {{ appName }} [&quot;SVIP&quot;] page. 3.8 Before your &quot;SVIP&quot;
    service expires, {{ appName }} will remind you that your &quot;SVIP&quot; is
    about to expire through site messages-system notifications, etc., and you
    can renew your &quot;SVIP&quot; through specific methods such as purchasing.
    If your &quot;SVIP&quot; expires, {{ appName }} will terminate the
    &quot;SVIP&quot; service. 3.9 You understand and agree that &quot;SVIP&quot;
    services are online commodities and virtual commodities, which are charged
    first and served later. The &quot;SVIP&quot; fee is the price of the online
    commodities corresponding to the &quot;SVIP&quot; service you purchased, not
    prepayment or Deposits, deposits, savings cards, etc., the &quot;SVIP&quot;
    service cannot be transferred or refunded once it is activated (such as if
    you are completely unable to use the &quot;SVIP&quot; service due to major
    flaws, etc. {{ appName }} breach of contract, as otherwise agreed in this
    agreement, or as required by laws and regulations) Except for situations
    where a refund is required or when you contact {{ appName }} through
    customer service and {{ appName }} determines that a refund is possible). If
    you do not accept the &quot;SVIP&quot; service, you can stop using the
    &quot;SVIP&quot; service or stop continuing the &quot;SVIP&quot; service.

    <div class="bt">Article 4 “SVIP” Code</div>

    4.1 After becoming a &quot;SVIP&quot;, you will enjoy various exclusive
    privileges. You can view the exclusive privileges of &quot;SVIP&quot; on the
    [TTSVIP-Exclusive Privileges-Privilege Details] page. In addition, in order
    to enhance your &quot;SVIP&quot; service experience, {{ appName }} will also
    provide various additional value-added services for free (including but not
    limited to dress-up privileges, identity privileges, etc.). Please refer to
    [TTSVIP-Exclusive Privileges] for the additional value-added services. -The
    relevant page information in &quot;Privilege Details&quot; shall prevail. If
    the &quot;SVIP&quot; privilege name under this agreement is inconsistent
    with the description on the page, it will not affect the content of the
    membership rights you actually enjoy. 4.2 You may not obtain “SVIP”
    qualifications by selling, transferring, misappropriating, or leasing other
    user accounts, or enjoy the exclusive rights and interests of “SVIP” by
    selling, transferring, misappropriating, lending, or leasing other “SVIP”
    accounts. 4.3 You understand and agree: {{ appName }} has the right to
    adjust the &quot;SVIP&quot; privileged content from time to time based on
    the overall planning of the service, changes in its own operating
    strategies, etc. You should pay attention to and understand changes in
    privileged content and policies in a timely manner. Before
    {{ appName }} adjusts the privileges, you may have enjoyed or are currently
    enjoying certain service contents or rights. You understand and accept that
    {{ appName }}’s adjustments to the privileges may have an impact on the
    rights and interests you have enjoyed or are currently enjoying, and agree
    to follow the adjusted rules. The privileged content may be used without
    requiring {{ appName }} to assume any responsibility. 4.4 If you violate
    this Agreement or {{ appName }}’s Terms of Service, {{ appName }} has the
    right to
    <div class="bt">take</div>
    one or more of the following measures: (1) Take technical means to delete,
    block or disconnect relevant information; (2) Modify, restrict, suspend or
    terminate all or part of the &quot;SVIP&quot; services; (3) Collect
    liquidated damages and offset any fees, points or rights you have paid but
    not used against the liquidated damages; if the liquidated damages are
    insufficient to compensate for the losses, you will be further required to
    compensate for the losses. &quot;SVIP&quot; service. 4.5 Please be
    responsible for properly and correctly keeping, using and maintaining your
    &quot;SVIP&quot; information, account information and account password.
    Please take necessary and effective confidentiality measures for your
    account information and account password. If your account and password are
    leaked due to reasons other than {{ appName }}, or losses are caused by
    improper storage, use, and maintenance, {{ appName }} does not assume any
    responsibility in this regard. At the same time, {{ appName }} has the right
    to take all measures to prevent a third party from operating your account
    when you or others complain about the situation, regardless of the third
    party&#39;s purpose and whether the acquisition method is bona fide or not.

    <div class="bt">Article 5 Suspension or termination of “SVIP” service</div>

    5.1 {{ appName }} has the right to interrupt or terminate the
    &quot;SVIP&quot; service provided to you when the following circumstances
    occur: (1) Your voluntary suspension or termination, including but not
    limited to failure to renew upon expiration; (2) You have committed or
    {{ appName }}’s independent judgment believes that you have committed any
    behavior that violates national laws, regulations or regulatory policies,
    violates this Agreement and {{ appName }}’s terms of service, and affects or
    may affect the reputation and interests of {{ appName }} or/and its
    affiliates; (3) In accordance with the provisions of laws, regulations,
    regulatory policies or the requirements of competent authorities; (4) For
    emergencies such as maintaining account and system security; (5) Force
    majeure (in view of the special nature of the Internet, force majeure also
    includes hacker attacks, major impacts caused by technical adjustments in
    the telecommunications sector, temporary shutdowns due to government
    controls, virus attacks, etc. that affect the normal operation of the
    Internet); (6) Other circumstances that {{ appName }} cannot resist. 5.2
    When the aforementioned termination occurs, you agree to the following
    handling methods: (1) “SVIP” rights that have been generated but not used
    will be automatically cleared and will not be discounted; (2) Unless
    otherwise stipulated by laws and regulations or otherwise stated by
    {{ appName }}, the &quot;SVIP&quot; fee collected to compensate for the
    losses suffered by {{ appName }} will not be refunded; (3) If the agreement
    is terminated due to your violation of this agreement, {{ appName }} has the
    right to require you to bear corresponding liability for breach of contract
    depending on the circumstances; (4) Unless otherwise provided by laws and
    regulations or otherwise stated by {{ appName }}, {{ appName }} does not
    assume any responsibility to you or third parties.

    <div class="bt">Article 6 Other Agreements</div>

    6.1 Notice (1) All notifications provided by {{ appName }} to users under
    this agreement can be made through web announcements, topic pages, site
    messages, client push, official account notifications, emails reserved by
    customers, mobile phone text messages or regular mail transmission, etc. ,
    such notices shall be deemed to have been delivered to the user on the date
    of sending. (2) In order to facilitate you to receive relevant
    notifications, you should ensure that the reserved contact information is
    correct and valid, and promptly log in to your {{ appName }} account to
    modify it after the change. If you fail to provide correct contact
    information or fail to notify the new contact information in a timely
    manner, , resulting in the inability to receive notifications in time, you
    will be responsible for the resulting losses and legal consequences. (3)
    {{ appName }} may deliver various notices to you through one or more of the
    above methods, and the content of such notices may have a significant
    beneficial or adverse impact on you. Please ensure that the contact
    information is valid and please pay attention in time. . 6.2 If you want to
    activate the automatic renewal function of the &quot;SVIP&quot; service, you
    need to additionally read and agree to the &quot;{{
      appName
    }}
    &quot;SVIP&quot; Automatic Renewal Service Agreement&quot;. The automatic
    renewal service agreement is a supplementary agreement to this agreement.
    Your acceptance of the supplementary agreement and specific business rules
    shall be deemed as your acceptance of this agreement in its entirety. 6.3 No
    matter whether part of the terms of this agreement is invalid or
    unenforceable for any reason, the remaining terms will still be valid and
    binding on both parties.
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>
<style scoped>
.protocol {
  font-size: 0.2267rem;
  margin-bottom: 0.4667rem;
  color: #666;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}
.bt {
  font-size: 0.4rem;
  margin: 0.2rem 0px;
  color: #7f1146;
}
</style>
